import { RootAction } from "../types";
import {
  VIDEOCHAT_FETCHED_CONSENT_MESSAGE,
  VIDEOCHAT_CONSENT_ACKNOWLEDGED,
  VIDEOCHAT_FETCH_CONSENT_MESSAGE_ERROR
} from "./actions";

export interface State {
  data: {
    localParticipantUid?: string;
    consentMessage?: string;
    consentAcknowledged: boolean;
  };
  loading: boolean;
  passsiveLoading: boolean;
}

const blankState = () => ({
  data: {
    localParticipantUid: undefined,
    consentMessage: "",
    consentAcknowledged: false
  },
  loading: true,
  passsiveLoading: false
});

export default (state: State = blankState(), action: RootAction) => {
  switch (action.type) {
    case VIDEOCHAT_FETCHED_CONSENT_MESSAGE:
      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          consentMessage: action.consentMessage
        }
      };
    case VIDEOCHAT_CONSENT_ACKNOWLEDGED:
      return {
        ...state,
        data: {
          ...state.data,
          consentAcknowledged: true
        }
      };
    case VIDEOCHAT_FETCH_CONSENT_MESSAGE_ERROR:
      return {
        ...state,
        loading: false
      };
    case "videoChat/initiateVideoChat-started":
      return {
        ...state,
        loading: true
      };
    case "videoChat/initiateVideoChat-success":
      return {
        ...state,
        loading: false,
        error: null,
        data: {
          ...state.data,
          localParticipantUid: action.localParticipantUid
        }
      };
    case "videoChat/initiateVideoChat-failure":
      return {
        ...state,
        loading: false
      };
  }

  return state;
};
